<template>
  <div class="cardTicket-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="卡券内容：" prop="ticketContent">
            <el-input v-model="form.ticketContent" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleAdd">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="ticketName" label="卡券名称" align="center"></el-table-column>
        <el-table-column prop="ticketContent" label="卡券内容" align="center"></el-table-column>
        <el-table-column label="卡券日期" align="center">
          <template
            slot-scope="scope"
          >{{scope.row.ticketBeginTime}}~{{scope.row.ticketEndTime}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="生成时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.ticketState"
              @click="handleShelves(scope.row.id,0)"
            >上架</span>
            <span
              class="dowmShelves"
              v-else
              @click="handleShelves(scope.row.id,1)"
            >下架</span>
            <span class="view" @click="handleView(scope.row.id)">查看</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getAssistantTicketList, updateAssistantTicketUp, updateAssistantTicketDown } from '@/api/cardTicket';
import Pagination from '@/components/Pagination';

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        ticketContent: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getAssistantTicketList();
  },
  methods: {
    getAssistantTicketList() {
      this.loading = true;
      getAssistantTicketList({
        ...this.form,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 上架
    updateAssistantTicketUp(id) {
      return updateAssistantTicketUp(id).then((res) => {
        if (res.success) {
          this.$message.success('上架成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 下架
    updateAssistantTicketDown(id) {
      return updateAssistantTicketDown(id).then((res) => {
        if (res.success) {
          this.$message.success('下架成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getAssistantTicketList();
    },
    // 上下架
    async handleShelves(id, state) {
      this.loading = true;
      if (state === 0) {
        await this.updateAssistantTicketUp(id).catch(() => {
          this.loading = false;
        });
      } else {
        await this.updateAssistantTicketDown(id).catch(() => {
          this.loading = false;
        });
      }
      this.getAssistantTicketList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getAssistantTicketList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getAssistantTicketList();
    },
    handleAdd() {
      this.$router.push({ name: 'CardTicketAdd' });
    },
    handleEditor(id) {
      this.$router.push({
        name: 'CardTicketEditor',
        query: {
          id,
        },
      });
    },
    // 查看
    handleView(id) {
      this.$router.push({
        name: 'CardTicketDetail',
        query: {
          id,
        },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.upShelves, .dowmShelves, .view, .editor
  color #1890ff
  cursor pointer
.upShelves, .dowmShelves, .view
  margin-right 20px
.storeImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
.phone
  margin-left 30px
>>>textarea
  min-height 90px !important
.operate
  width 240px
  flex-row-nowrap()
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
